<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.ggsc1">&nbsp;&nbsp;
        <img :src="images.ggsc2" style="line-height:1.5;">&nbsp;&nbsp;
        <img :src="images.ggsc3" style="line-height:1.5;">&nbsp;&nbsp;
        <img :src="images.ggsc4" style="line-height:1.5;">
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">铜管生产线</span>
        </b>
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">
            <br>
          </span>
        </b>
      </p>
      <p>
        <span
          style="font-family:宋体;font-size:12pt;text-indent:84pt;line-height:1.5;"
        >本公司可以提供从设计，设备提供到验收合格的一条龙服务。</span>
      </p>
      <p style="margin-left:-82.85pt;text-indent:84.0pt;">
        <br>
        <br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        <img
          :src="images.ggsc5"
        >&nbsp;
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        ggsc1: require("../../../assets/img/common/ggsc1.jpg"),
        ggsc2: require("../../../assets/img/common/ggsc2.jpg"),
        ggsc3: require("../../../assets/img/common/ggsc3.jpg"),
        ggsc4: require("../../../assets/img/common/ggsc4.jpg"),
        ggsc5: require("../../../assets/img/common/ggsc5.gif")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/device/ggsc.vue